import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Scrollable } from '#src/atoms/navigation/Scrollable/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';

export const ResponsiveRaritiesWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isLaptop = useIsLaptop();

  if (isLaptop) {
    return (
      <Vertical gap={0.5} className="overflow-x-auto overflow-y-hidden">
        {children}
      </Vertical>
    );
  }
  // use a scrollable container for mobile
  return (
    <Scrollable itemToDisplay={4} overhang contained withScrollButtons={false}>
      {children}
    </Scrollable>
  );
};
